//#region Components
import ResourcesLibrary from "views/Recursos/ResourcesLibrary/ResourcesLibrary";
import ResourcesUniversitySpaces from "views/Recursos/ResourcesUniversitySpaces";
//#endregion
//#region Utils
import { PERMISSIONS_VIEWS } from "config/userPermissions";
//#endregion

const { RECURSOS } = PERMISSIONS_VIEWS;

export const RESOURCE_MODULE_TITLES = {
    LIBRARY: "Biblioteca",
    UNIVERSITY_SPACES: "Espacios Universitarios"
};
export const ALLOWED_RESOURCE_MODULES = [
    RECURSOS.BIBLIOTECA,
    RECURSOS.ESPACIOS_UNIVERSITARIOS,
    // RECURSOS.OTROS
];
export const onlyResourceModules = ({ id }) => ALLOWED_RESOURCE_MODULES.includes(id);
export const RESOURCE_MODULES = [
    {
        id: RECURSOS.BIBLIOTECA,
        path: "biblioteca",
        View: ResourcesLibrary
    },
    {
        id: RECURSOS.ESPACIOS_UNIVERSITARIOS,
        path: "espacios-universitarios",
        View: ResourcesUniversitySpaces
    },
].filter(onlyResourceModules);

/* Nota: Habilitación de filtros de Tipo de espacio, deporte, código de alumno */
export const ENABLE_FILTERS_OF_SPACE_TYPE__SPORTS__STUDENT_CODE = true;